import React from "react";

const HowItWorks: React.FC = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 text-gray-800">
            <h1 className="text-3xl sm:text-4xl font-bold text-center mb-6 sm:mb-10 leading-tight">
                🧠 How It Works
            </h1>

            <p className="text-base sm:text-lg mb-8 text-center text-gray-600">
                Welcome to <strong>Quizora</strong> — your chance to win <strong>laptops, gadgets, and more</strong>
                by showcasing your skills, all at just a fraction of the price.
            </p>

            <ol className="space-y-10">
                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">✅ Step 1: Create Your Account</h2>
                    <p className="text-gray-700">
                        Sign up using your <strong>email address</strong> and create a <strong>user ID and password</strong>.
                        This grants access to your personal Quizora dashboard.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">🗓️ Step 2: Registration Announcement</h2>
                    <p className="text-gray-700">
                        We’ll announce the <strong>exam registration date and time</strong> via email and website.
                        Participants must <strong>pay the entry fee</strong> to receive their <strong>hall ticket</strong>.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">📣 Step 3: Exam Schedule Notification</h2>
                    <p className="text-gray-700">
                        Once registration is complete, the <strong>exam date and time</strong> will be announced via email and on the website.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">🧾 Step 4: Enter the Exam</h2>
                    <p className="text-gray-700">
                        On exam day, log in using your <strong>email ID</strong> and <strong>hall ticket number</strong> to begin the test.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">🧩 Step 5: Take the Aptitude Test</h2>
                    <p className="text-gray-700">
                        You'll be given a set of <strong>aptitude questions</strong> (each with 4 options) to complete within a
                        specified <strong>time limit</strong>. The number of questions and the duration may vary based on the contest.
                    </p>
                    <p className="mt-2 text-gray-700">
                        <strong>Scoring:</strong> +2 for each correct answer, -1 for each incorrect answer.
                    </p>
                    <p className="mt-1 italic text-sm text-gray-600">
                        Example: 15 correct = 30, 15 wrong = -15 → Total = 15 marks.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">🏆 Step 6: Scoreboard & Results</h2>
                    <p className="text-gray-700">
                        Results will be posted in the <strong>Scoreboard</strong> section within <strong>24 hours</strong>.
                        You can view your score in your dashboard.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">🥇 Step 7: Winner Selection</h2>
                    <p className="text-gray-700">
                        The winner is the participant with the <strong>highest score</strong> in the <strong>shortest time</strong>.
                        Our system ensures fairness and accuracy.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">🎁 Step 8: Claiming Your Prize</h2>
                    <p className="text-gray-700">
                        Winners must submit their <strong>PAN card</strong> and <strong>Aadhaar card</strong> for prize verification.
                        Under <strong>Section 194B</strong>, 30% TDS applies, but <strong>Quizora covers this</strong>.
                        You’ll receive the <strong>full prize amount</strong> with a valid <strong>TDS certificate</strong>.
                    </p>
                </li>

                <li>
                    <h2 className="text-lg sm:text-xl font-semibold">📆 Monthly Events</h2>
                    <p className="text-gray-700">
                        We host <strong>4 contests every month</strong> — giving you more chances to win and compete.
                    </p>
                </li>
            </ol>

            <div className="mt-16 text-center">
                <p className="text-lg sm:text-xl font-semibold mb-2">💡 Ready to play?</p>
                <p className="text-gray-700">
                    Join Quizora now, register on time, and let your knowledge earn you premium rewards!
                </p>
            </div>
        </div>
    );
};

export default HowItWorks;
